<Title date="2025-09-23" slug="open-sourcing-demos">
  Demos is now Open Source
</Title>

After almost three years of building Demos as a paid resource, I've decided to make all 110+ React Native animations completely open source. It feels like the right time to share this collection of Reanimated, Gesture Handler, and React Native Skia examples with everyone.

<GithubCard repo="enzomanuelmangano/demos" />

## For existing Supporters

If you purchased Demos—whether yesterday or years ago—you are eligible for a full refund. Your support has meant the world to me, and this transition shouldn't cost you anything.

You'll still be able to support my work if you choose to, but it won't be a requirement anymore to access the repo.

Options to request your refund:

- [Twitter DM](https://x.com/reactiive_)
- [LinkedIn DM](https://www.linkedin.com/in/enzomanuelmangano/)
- [Email me at hello@reactiive.io](mailto:hello@reactiive.io)

Your support genuinely meant everything to me and pushed me forward as both a developer and creator. That hasn't changed, and I hope it never will.

## Why this shift?

When I started my YouTube channel, I had one rule: create content that adds value while teaching me something new. That led to Patreon, then Demos—each step trying to balance free content with supporter benefits.

But scrolling through my Twitter recently, I had an uncomfortable realization. My profile looked more like a paywall than a place where I share valuable insights. Instead of focusing on the creative process behind animations, my posts had become previews of paid content.

It wasn't intentional, but it happened. And honestly? It didn't feel right anymore.

Without consistently sharing real value, it's impossible to build anything meaningful in the long run.

**Open-sourcing Demos feels like the way to fix that.**

## What’s changing?

I'll continue to share animations (that's just something I enjoy too much).

Future posts will probably look more like threads 🧵.

I’ll dive deeper into the approach behind each animation—the thinking, the challenges, the solutions. You'll get the code and understand how it works.

Over the past few years, I’ve aimed to keep a rhythm of one animation per week, though lately that’s shifted. I’d like to return to that consistency, but I’ll happily break the rule if waiting means delivering something truly worth it.

## What’s next?

The Demos repo is live and mostly stable, though I’m still addressing consistency issues between older and newer animations, as well as improvements required for the Expo 54 upgrade.

A TestFlight build will be available soon, so you can try everything hands-on. This shouldn’t take too long.

## What about my animations course?

[Reanimate.dev](https://reanimate.dev) will become my unique paid offering, and I'll focus mid-term on updating the course with Reanimated v4 tutorials (Shared transitions are almost here!).

I think that with AI, programming is changing a lot, but somehow doing animations is still something that requires a lot of handmade crafting, and I’m excited to keep exploring that with you.

---

This ended up longer than I planned, but thanks for sticking with me. And seriously, thanks for supporting this journey.
